<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">회원관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사업자회원</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="일반회원">일반회원</router-link></li>
            <li><router-link to="/businessmembership" title="사업자회원">사업자회원</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사업자회원 상세정보</h3>
        <article>
          <div class="table horizontal-table">
            <table>
              <caption>
                사업자회원 상세정보 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 100px" />
                <col style="width: 35%" />
                <col style="width: 15%; min-width: 100px" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">아이디</th>
                  <td colspan="3">{{ employeeInfo.empNo }}</td>
                </tr>
                <tr>
                  <th scope="row">법인(단체명)</th>
                  <td colspan="3">{{ employeeInfo.companyNm }}</td>
                </tr>
                <tr>
                  <th scope="row">대표자명</th>
                  <td colspan="3">{{ employeeInfo.empNm }}</td>
                </tr>
                <tr>
                  <th scope="row">사업자등록번호</th>
                  <td colspan="3">{{ employeeInfo.companyNo }}</td>
                </tr>
                <tr>
                  <th scope="row">개업일자</th>
                  <td colspan="3">{{ employeeInfo.openDt }}</td>
                </tr>
                <tr>
                  <th scope="row">사업자 연락처</th>
                  <td colspan="3">{{ employeeInfo.empTelNo }}</td>
                </tr>
                <tr>
                  <th scope="row">사업자 전화번호</th>
                  <td colspan="3">{{ employeeInfo.empMobile }}</td>
                </tr>
                <tr>
                  <th scope="row">사업자 주소</th>
                  <td colspan="3">{{ employeeInfo.addr }}</td>
                </tr>
                <tr>
                  <th scope="row">웹 선불권 신청주차장</th>
                  <td>
                    <div v-for="(item, index) in pickSectnId" :key="index" class='flex ac'>{{ item.PARKING_NM }}
                      <button v-if="item.PARKING_NM == '남천상가' || item.PARKING_NM == '창전동 임시공영'" type='button' class="btn blue"  @click="marketBtn()" style='margin-left: 8px'>{{ market == 'Y' ? '전통시장승인취소' : '전통시장승인' }}</button>
                    </div>

                  </td>
                  <div v-if="isNamcheon">
                    <th scope="row">무료 웹 선불권 서비스</th>
                    <td>사용</td>
                  </div>
                </tr>
                <tr v-if="attachList.length!=0">
                  <tr v-for="(item, idx) in attachList" :key="idx">
                    <th scope="row">첨부파일</th>
                    <td colspan="3"><a @click="downloadAttachFile(item.filePath, item.saveNm, item.viewNm, item.fileExt, item.repoId)" class="fileName">{{ item.viewNm }}</a></td>
                  </tr>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button type="button" class="btn border" @click="pwLockInit">비밀번호 잠금 해제</button>
          <button type="button" class="btn border" @click="goList">목록</button>
          <button type="button" class="btn blue" @click="approvalBtn">{{ status == 'A' ? '승인' : '승인취소' }}</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import instance from 'axios';

export default {
  data() {
    return {
      empId: '',
      employeeInfo: {},
      pickSectnId: [],
      status: 'A',
      market: this.$store.state.marketYn,
      isNamcheon: false,
      attachList: [],
    };
  },

  mounted() {
    const empId = this.$route.query.id;
    if (!empId) {
      alert('잘못된 접근입니다.');
      this.$router.push('/businessmembership');
    }
    this.empId = empId;
    this.findMember();
  },

  methods: {
    async findMember() {
      const apiParams = new FormData();
      apiParams.append('empEsntlId', this.empId);
      const res = await axios('post', '/api/member/view.json', apiParams);

      this.employeeInfo = res.data.resultVo;
      this.pickSectnId = res.data.mappingList;
      this.attachList = res.data.memberFileList || [];
      this.status = this.employeeInfo.empSttus;
    },

    async pwLockInit() {
      const apiParams = new FormData();
      apiParams.append('empEsntlId', this.empId);
      await axios('post', '/api/member/pw-lock-init', apiParams);
      alert('적용되었습니다.');
    },

    goList() {
      this.$router.push('/businessmembership');
    },

    setDefer() {
      alert('보류 되었습니다.');
    },

    approvalBtn() {
      // TODO: axios통합, es6전환

      let apiParams = new FormData();
      let apiData = new FormData();
      apiParams.append('empEsntlId', this.$route.query.id);
      if (this.employeeInfo.empSttus == 'A') {
        apiParams.append('empSttus', 'P');
        if (confirm('승인하시겠습니까?')) {
          instance
            .post('/api/member/updateSttus.json', apiParams)
            .then(response => {
              apiData.append('uniqId', this.$route.query.id);
              apiData.append('authorCode', 'ROLE_STORE');
              instance
                .post('/api/member/updateAuth.json', apiData)
                .then(response => {
                  alert('승인되었습니다.');
                })
                .catch(function (error) {
                  console.error(error);
                });
              this.findMember();
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      } else {
        apiParams.append('empSttus', 'A');
        if (confirm('승인취소하시겠습니까?')) {
          instance
            .post('/api/member/updateSttus.json', apiParams)
            .then(response => {
              apiData.append('uniqId', this.$route.query.id);
              apiData.append('authorCode', 'ROLE_ANONYMOUS');
              instance
                .post('/api/member/updateAuth.json', apiData)
                .then(response => {
                  alert('승인취소되었습니다.');
                })
                .catch(function (error) {
                  console.error(error);
                });
              this.findMember();
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      }
    },

    marketBtn() {
      // TODO: axios통합, es6전환

      let apiParams = new FormData();
      apiParams.append('empEsntlId', this.$route.query.id);
      if (this.market == 'N') {
        apiParams.append('marketYn', 'Y');
        if (confirm('전통시장 할인을 승인하시겠습니까?')) {
          instance
            .post('/api/member/updateMarket.json', apiParams)
            .then(response => {
              alert('승인되었습니다.');
              this.$store.dispatch("marketYn", 'Y');
              this.market = 'Y';
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      } else {
        apiParams.append('marketYn', 'N');
        if (confirm('전통시장 할인을 취소하시겠습니까?')) {
          instance
            .post('/api/member/updateMarket.json', apiParams)
            .then(response => {
              alert('승인취소되었습니다.');
              this.$store.dispatch("marketYn", 'N');
              this.market = 'N';
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      }
    },

    downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
			location.href = "/api/member/download.json?filePath=" + filePath + "&saveNm=" + saveNm + "&viewNm=" + viewNm + "&fileExt=" + fileExt + "&repoId=" + repoId;
		},
  },
};
</script>
